import React from 'react';
import { EDSDataGrid } from '@gehc-eds-react/eds-datagrid';
import { EDSBadge } from '@gehc-eds-react/eds-badge';
import { EDSButton } from '@gehc-eds-react/eds-button';
import { EDSDataGridContainer } from '@gehc-eds-react/eds-datagrid-container';
import { EDSSearch } from '@gehc-eds-react/eds-search';
import { EDSPagination } from '@gehc-eds-react/eds-pagination';

const ContractsList = ({ 
  contracts = [], 
  onSelectContract, 
  selectedContract,
  pagination = {},
  onPreviousPage,
  onNextPage,
  onPageNumberClick,
  isLoading = false,
  searchTerm = '',           
  onSearchInput,             
  onSearchClear 
}) => {

  const contractColumns = {
    "ContractID": { "displayName": "Contract ID", "isPrimary": true, "isHidden": true },
    "ContractDisplayName": {
      "displayName": "Contract Name",
      renderCellValue: (contractDisplayName, row) => (
        <span
          className="menu-link"
          onClick={() => onSelectContract(row)}
          style={{
            cursor: "pointer",
            color: selectedContract?.ContractID === row.ContractID ? "#fff" : "#7252BC",
            textDecoration: "underline",
            fontWeight: selectedContract?.ContractID === row.ContractID ? "bold" : "normal",
            display: "block",
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
          title={contractDisplayName || row.Name}
        >
          {contractDisplayName || row.Name}
        </span>
      )
    },

    "Project": { 
      "displayName": "Project Name",
      renderCellValue: (project) => (
        <span style={{ 
          maxWidth: "150px", 
          overflow: "hidden", 
          textOverflow: "ellipsis", 
          whiteSpace: "nowrap",
          display: "block"
        }} title={project}>
          {project}
        </span>
      )
    },

    "StartDate": {
      "displayName": "Start Date",
      renderCellValue: (startDate) => (
        <span>
          {startDate ? new Date(startDate).toLocaleDateString() : '—'}
        </span>
      )
    },
    "EndDate": {
      "displayName": "End Date",
      renderCellValue: (endDate) => (
        <span>
          {endDate ? new Date(endDate).toLocaleDateString() : '—'}
        </span>
      )
    },

    "ContractStatus": {
      "displayName": "Contract Status",
      renderCellValue: (contractStatus) => (
        <EDSBadge
          variant={contractStatus === 'APPROVED' ? 'success' : 'warning'}
          value={contractStatus}
          size="small"
        />
      )
    }
  };

  const gridKey = `contracts-grid-${pagination.currentPage}-${contracts.length}`;

  return (
    <div className="contracts-section" style={{ width: '100%'}}>
      <div className='upload-data-section'>
        <h3 className='u-mt0 u-mb0'>Available Contracts</h3>
        <div className='flex'>
          <span style={{'width':'350px'}}>
            <EDSSearch
              useSearchButton={false}
              variant={"type-in"}
              addListOption={"beginning"}
              placeholder={"Search contracts..."}
              searchTerm={searchTerm}
              onEDSSearchInput={onSearchInput}
              onEDSSearchClear={onSearchClear}
            />
          </span>
        </div>
      </div>
      
      <div style={{ width: '100%' }}>
        <EDSDataGrid
          key={gridKey}
          columnConfig={contractColumns}
          rows={contracts}
          gridFeatures={["row-hover", "table-flex-horizontal"]}
          rowFormat={{ "size": "compact", "style": "divider" }}
          activeRowId={selectedContract?.ContractID}
          isLoading={isLoading}
          loaderType={"activity-indicator-linear"}
          labels={{
            "rowText": "rows of",
            "noRowsFoundText": "No Rows Found",
            "noFilterResultsText": "No results found",
            "emptyGridMessage": "There is no contract associated for upload",
            "emptyGridSecondaryText": "",
            "noFilterResultsSecondaryText": "Try adjusting your search to find contracts"
          }}
          visibleRowCount={Math.min(10, contracts.length || 1)}
          totalRowCount={contracts.length}
        />

        {/* EDS Pagination */}
        {pagination.total > 0 && pagination.total > pagination.pageSize && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0',
            marginTop: '8px'
          }}>
            <div style={{ fontSize: '13px', color: '#666' }}>
              {(() => {
                const start = (pagination.currentPage - 1) * pagination.pageSize + 1;
                const end = Math.min(
                  pagination.currentPage * pagination.pageSize,
                  pagination.total
                );
                return `${start}-${end} of ${pagination.total} contracts`;
              })()}
            </div>
            <EDSPagination
              totalRecords={pagination.total}
              pageSizeOptions={{
                value: pagination.pageSize,
                options: [],
                label: ""
              }}
              currentPage={pagination.currentPage}
              onEDSPaginationPageNumberClick={onPageNumberClick}
              onEDSPaginationPageNextClick={onNextPage}
              onEDSPaginationPagePreviousClick={onPreviousPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractsList;